import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetDeliveryOrdersParams,
    GetDeliveryOrdersResponse,
    DownloadReportParams,
} from '@/new-services/types/delivery'

type ApiGetDeliveryOrdersResponse = Promise<AxiosResponse<GetDeliveryOrdersResponse>>
type ApiDownloadReportResponse = Promise<AxiosResponse<any>>

export function getDeliveryOrders(params: GetDeliveryOrdersParams): ApiGetDeliveryOrdersResponse {
    return http.get('/dispatcher/api/deliveries', { params })
}

export function downloadReport(params: DownloadReportParams): ApiDownloadReportResponse {
    return http.get(`/dispatcher/api/deliveries/report`, { params, responseType: 'blob' })
}

export default {
    getDeliveryOrders,
    downloadReport,
}
